
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import {AUTH_CHANGE_PASSWORD_WITH_RECOVERY_CODE, AUTH_VALIDATE_RECOVERY_CODE} from '@/store/action-types'
import {ChangePasswordWithRecoveryCodePayload} from '@/types/payload'
import {valueIsRequired, checkPasswordLength} from '@/services/validation'

@Component({})
export default class SetNewPassword extends Vue {
  $refs!: {
    form: Vue & { validate(): boolean, resetValidation(): void }
  }

  @Prop({required: true}) recoveryCode!: string

  private validationInProgress: boolean = false
  private isSaveInProgress: boolean = false
  private isCodeValid: boolean = false
  private isFormValid: boolean = false
  private passwordChangedSuccessfully: boolean = false
  private newPassword: string | null = null
  private passwordValidationRules: Function[] = [valueIsRequired, checkPasswordLength]

  get buttonHeight(): number | undefined {
    if (this.$vuetify.breakpoint.smAndDown) {
      return 64
    }
  }

  @Action(AUTH_VALIDATE_RECOVERY_CODE) validateRecoveryCode!: { (recoveryCode: string): Promise<void> }
  @Action(AUTH_CHANGE_PASSWORD_WITH_RECOVERY_CODE) changePassword!: { (payload: ChangePasswordWithRecoveryCodePayload): Promise<void> }

  onRetryButtonClick(): void {
    this.$router.replace({name: 'PasswordRecovery'})
  }

  onFinalizeButtonClick(): void {
    this.$router.replace({name: 'Login'})
  }

  async onFormSubmit(): Promise<void> {
    if (this.$refs.form.validate()) {
      const payload: ChangePasswordWithRecoveryCodePayload = {
        password: this.newPassword!,
        recoveryCode: this.recoveryCode
      }

      try {
        this.isSaveInProgress = true

        await this.changePassword(payload)
        this.passwordChangedSuccessfully = true
      } catch (e) {
        this.isCodeValid = false
      } finally {
        this.isSaveInProgress = false
      }
    }
  }

  async validateCode(): Promise<void> {
    try {
      this.validationInProgress = true

      await this.validateRecoveryCode(this.recoveryCode)
      this.isCodeValid = true
    } finally {
      this.validationInProgress = false
    }
  }

  mounted() {
    this.validateCode()
  }
}
